import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Пары «ярлык — значение» в две колонки.
 *
 * Проверено грепом: во всём apps/web не было ни одного display: grid и ни
 * одного flex-wrap за пределами фильтра меток. Поэтому короткое значение —
 * пол, возраст, раса, количество родинок — раздувалось в блок во всю ширину
 * экрана, и анкета читалась как лента одинаковых полос.
 */

export interface Fact {
  label: string;
  /**
   * Пустое значение пропускается: половина полей анкеты необязательна.
   * Узел, а не строка: «Владелец» — это ссылка на профиль ВК, и ради неё
   * два экрана держали свой Fact с инлайновыми стилями.
   */
  value: ReactNode;
  /** Занять обе колонки. Для ФИО по-английски и подобных длинных строк. */
  wide?: boolean;
}

export function FactGrid({ facts }: { facts: Fact[] }) {
  const shown = facts.filter(
    (fact) => fact.value !== null && fact.value !== undefined && fact.value !== '',
  );
  if (shown.length === 0) return null;

  return (
    <div className={styles.factGrid}>
      {shown.map((fact) => (
        <div key={fact.label} className={clsx(styles.fact, fact.wide === true && styles.factWide)}>
          <div className={styles.factLabel}>{fact.label}</div>
          <div className={styles.factValue}>{fact.value}</div>
        </div>
      ))}
    </div>
  );
}
